module.exports = __webpack_public_path__ + "static/media/TE.625582a9.png";